<div class="modal-header on_dark">
    <h3>Confirm Account Number</h3>
    <aurora-icon-button
        icon="times"
        variant="ghost"
        size="xlarge"
        class="close"
        aria-label="Close"
        (click)="cancel()"></aurora-icon-button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="accountNumber">Account Number</label>
      <kendo-maskedtextbox
        id="accountNumber"
        formControlName="accountNumber"
        [appNumberingMask]="editMask"
        [title]="helpText"
        [includeLiterals]="true"
      ></kendo-maskedtextbox>
    </div>
  </form>
</div>

<div class="modal-footer">
    <aurora-button [disabled]="!form.valid" (click)="save()">Save</aurora-button>
    <aurora-button variant="tertiary" class="ms-2" (click)="cancel()">Cancel</aurora-button>
</div>
